var React = require('react');

function RoundLeft (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"31.25","y":"0.75","width":"30.5","height":"30.5","rx":"15.25","transform":"rotate(90 31.25 0.75)","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.3739 22.0405C17.9833 22.431 17.3502 22.431 16.9596 22.0405L11.6263 16.7071C11.2358 16.3166 11.2358 15.6834 11.6263 15.2929L16.9596 9.95958C17.3502 9.56906 17.9833 9.56906 18.3739 9.95958C18.7644 10.3501 18.7644 10.9833 18.3739 11.3738L13.7476 16L18.3739 20.6262C18.7644 21.0168 18.7644 21.6499 18.3739 22.0405Z","fill":"#8C8C8C","key":1}),React.createElement("rect",{"x":"31.25","y":"0.75","width":"30.5","height":"30.5","rx":"15.25","transform":"rotate(90 31.25 0.75)","stroke":"#EDEDED","strokeWidth":"1.5","key":2})]);
}

RoundLeft.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = RoundLeft;

RoundLeft.default = RoundLeft;
